export default __webpack_public_path__ + "static/media/Fabforeman.cf96c26e.png";